import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { Storage } from '@mui/icons-material';
import { AsrsType, ServerVm } from 'api/asrs/server.vm';
import { useNavigate } from 'react-router-dom';
import { getServers } from 'api/asrs/get-servers';
import { GetServersVm } from 'api/asrs/get-servers.vm';

const AsrsServersPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [servers, setServers] = useState<ServerVm[]>([]);
  const [loading, setLoading] = useState(false);
  const [nextOffset, setNextOffset] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchServers = (offset: string | null, reset: boolean = false) => {
    setLoading(true);
    getServers(offset || '', {
      success: (response: GetServersVm) => {
        setHasMore(response.nextOffset !== null && response.nextOffset !== '');
        setNextOffset(response.nextOffset);
        setServers(reset ? response.objects : [...servers, ...response.objects]);
        setLoading(false);
      },
      error: (err) => {
        console.error('Falha ao carregar servidores:', err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchServers(null, true);
  }, []);

  const handleLoadMore = () => {
    if (!hasMore || !nextOffset) return;
    fetchServers(nextOffset);
  };

  const handleRowClick = (serverId: string) => {
    navigate(`/warehouse/asrs-servers/${encodeURIComponent(serverId)}`);
  };

  const getTypeChip = (type: AsrsType) => {
    const labelMap = {
      [AsrsType.KARDEX]: 'Kardex',
    };
    return <Chip label={labelMap[type]} color={'info'} size="small" />;
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          Armazenamento Automatizado
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: theme.palette.grey[800] }}>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Host</TableCell>
              <TableCell>Porta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {servers.map((server) => (
              <TableRow key={`${server.host}:${server.port}`} hover onClick={() => handleRowClick(server.id)} sx={{ cursor: 'pointer' }}>
                <TableCell>{server.name}</TableCell>
                <TableCell>{getTypeChip(server.type)}</TableCell>
                <TableCell>{server.host}</TableCell>
                <TableCell>{server.port}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        {loading ? (
          <CircularProgress />
        ) : hasMore ? (
          <Button variant="outlined" onClick={handleLoadMore} disabled={loading || !nextOffset}>
            Carregar mais
          </Button>
        ) : servers.length > 0 ? (
          <Typography variant="body2" color="textSecondary">
            Não existem mais servidores para carregar
          </Typography>
        ) : (
          <Typography variant="body2" color="textSecondary">
            Nenhum servidor encontrado
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AsrsServersPage;
